const IMAGE_UPLOAD_URL =
    `${import.meta.env.VITE_IMAGE_SERVER_URL}/upload`;

const IMAGE_DELETE_URL =
    `${import.meta.env.VITE_IMAGE_SERVER_URL}/delete`;


// ============================================================
// UPLOAD PHOTO
// ============================================================
export const serviceUploadPhoto = async ({
    file,
    folder,
    filename,
}) => {
    const formData = new FormData();

    formData.append("photo", file);
    if (folder) {
        formData.append("folder", folder);
    }
    if (filename) {
        formData.append("filename", filename);
    }

    const response = await fetch(
        IMAGE_UPLOAD_URL,
        {
            method: "POST",
            body: formData
        }
    )

    const data = await response.json();

    if (!response.ok) {
        throw new Error(data?.error || "Photo upload failed");
    }

    return data;
};

// ============================================================
// DELETE PHOTO
// ============================================================
export const serviceDeletePhoto = async (imageUrl) => {
    const response = await fetch(
        IMAGE_DELETE_URL,
        {
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                imageUrl
            })
        });

    const data = await response.json();

    if (!response.ok) {
        throw new Error(data?.error || "Photo delete failed");
    }

    return data;
}